import { z } from "zod";

export const AssetMediaType = z.enum(["IMAGE", "VIDEO"]);
export const AssetMediaStatus = z.enum(["COMPLETED", "PROCESSING", "FAILED"]);

export const AssetMediaMetadata = z.object({
  tags: z.array(z.string()),
});

export const AssetMediaDto = z.object({
  status: AssetMediaStatus,
  isTransparentVideo: z.boolean(),
  externalId: z.string(),
  src: z.string(),
  type: AssetMediaType,
  width: z.number().nullable(),
  height: z.number().nullable(),
  thumbnailSrc: z.string().nullable(),
  metadata: AssetMediaMetadata.nullable(),
});

export const UpdateAssetMediaDto = z.object({
  metadata: AssetMediaMetadata,
});

export const SyncAssetMediasTagsDto = z.object({
  assetMediaExternalIds: z.array(z.string()).min(1),
  tags: z
    .array(
      z.object({
        tag: z.string(),
        selectedExternalIds: z.array(z.string()),
      }),
    )
    .min(1),
});

export const AssetMediaAsyncCompletedDto = z.object({
  status: z.literal("COMPLETED"),
  data: AssetMediaDto,
});

export const AssetMediaAsyncDto = z.union([
  AssetMediaAsyncCompletedDto,
  z.object({
    status: z.enum(["PENDING", "FAILED"]),
  }),
]);

export const GetAssetMediasBodyDto = z.object({
  assetMediaExternalIds: z.array(z.string()),
  status: AssetMediaStatus.optional(),
});

export const GetAssetMediasResponseDto = z.record(
  z.string(),
  AssetMediaDto.nullable(),
);

export const DeleteAssetMediasDto = z.object({
  externalIds: z.array(z.string()).min(1),
});

export const DeleteAssetMediasResponseDto = z.object({
  deletedCount: z.number(),
});

export type AssetMediaStatus = z.infer<typeof AssetMediaStatus>;
export type AssetMediaDto = z.infer<typeof AssetMediaDto>;
export type UpdateAssetMediaDto = z.infer<typeof UpdateAssetMediaDto>;
export type SyncAssetMediasTagsDto = z.infer<typeof SyncAssetMediasTagsDto>;
export type AssetMediaMetadata = z.infer<typeof AssetMediaMetadata>;
export type AssetMediaAsyncDto = z.infer<typeof AssetMediaAsyncDto>;
export type AssetMediaAsyncCompletedDto = z.infer<
  typeof AssetMediaAsyncCompletedDto
>;
export type GetAssetMediasBodyDto = z.infer<typeof GetAssetMediasBodyDto>;
export type GetAssetMediasResponseDto = z.infer<
  typeof GetAssetMediasResponseDto
>;
export type AssetMediaType = z.infer<typeof AssetMediaType>;
export type DeleteAssetMediasDto = z.infer<typeof DeleteAssetMediasDto>;
export type DeleteAssetMediasResponseDto = z.infer<
  typeof DeleteAssetMediasResponseDto
>;
